export default __webpack_public_path__ + "static/media/SpeakToExperiencedHeartNurse_584x386.8f6d9308.png";